import { useState } from "react";
import { useNavigate } from "react-router";

import {
  Button,
  Heading,
  Link,
  MarketingIcon,
  UiIcon
} from "@icg360/design-system";

import liftLockShingleResealingProgram from "../../assets/liftlock-shingle-resealing-program.pdf";
import { type Quote } from "../../types";
import styles from "./LiftLockFooter.module.css";

interface LiftLockFooterProps {
  price: Quote["roofResealingPaymentAmount"];
  blockType: Quote["roofResealingType"];
}

export const LiftLockFooter = ({ price, blockType }: LiftLockFooterProps) => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);

  if (!price) {
    return;
  }

  const isCreditBlock = blockType === "credit";

  return (
    <div className={styles.footerWrapper}>
      <button onClick={() => setCollapsed(!collapsed)}>
        <div className={styles.collapsibleIcon}>
          <UiIcon name={collapsed ? "ArrowUp" : "ArrowDown"} />
        </div>
      </button>
      {/* the onclick is the div is ok because the same action is on the button above */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div className={styles.content} onClick={() => setCollapsed(!collapsed)}>
        <span className={styles.iconWrapper}>
          <MarketingIcon name="Tools" size="lg" />
        </span>
        <div className={styles.mainWrapper}>
          <Heading size={isCreditBlock ? "sm" : "md"}>
            {isCreditBlock
              ? "Rating premium credit available on purchase of shingle resealing"
              : "Shingle reseal needed to purchase"}
          </Heading>
          <p className={collapsed ? styles.collapsedContent : ""}>
            {isCreditBlock
              ? "Your house is eligible for a credit on the hurricane portion of the premium. Purchase shingle resealing now to secure this credit for your policy. "
              : "Reseal your roof with LiftLock LLC to become eligible for this policy. Act now to insure your home. "}
            <Link target="_blank" href={liftLockShingleResealingProgram}>
              Learn more
            </Link>
          </p>
        </div>
        <div className={styles.rightWrapper}>
          <span className={styles.price}>
            <Heading size="xl" className={styles.priceDesktop}>
              ${+price}
            </Heading>
            <Heading size="lg" className={styles.priceMobile}>
              ${+price}
            </Heading>{" "}
            flat rate
          </span>
          <div className={styles.desktopButton}>
            <Button onPress={() => void navigate("liftlock")}>
              Reseal my roof with LiftLock
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.mobileButton}>
        <Button onPress={() => void navigate("liftlock")} fluid>
          Reseal my roof with LiftLock
        </Button>
      </div>
    </div>
  );
};
